import { render, staticRenderFns } from "./StateCommentDocuments.vue?vue&type=template&id=53efb58b&scoped=true&"
import script from "./StateCommentDocuments.vue?vue&type=script&lang=js&"
export * from "./StateCommentDocuments.vue?vue&type=script&lang=js&"
import style0 from "./StateCommentDocuments.vue?vue&type=style&index=0&id=53efb58b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53efb58b",
  null
  
)

export default component.exports